export const TERMS_TAB = 'TERMS_TAB';
export const PAYMENT_TAB = 'PAYMENT_TAB';
export const ADD_FUNDS_TAB = 'ADD_FUNDS';
export const PHONE_VERIFICATION = 'phone verification';

// UPS Terms constants
export const UPS_SUPPLEMENTAL_TERMS = 'UpsSupplementalTerms';
export const UPS_TECHNOLOGY_AGREEMENT = 'UpsTechnologyAgreement';
export const UPS_PROHIBITED_ITEMS = 'UpsProhibitedItems';
export const HAS_ACCEPTED_UPS_LABEL_TERMS_SETTING = 'HasAcceptedUpsLabelTerms';

// Error pattern for Stamps.com bad credentials
export const STAMPS_BAD_CREDENTIALS_REGEX = /.*Stamps\.com.*username.*password.*invalid/;

export const REGISTRATION_REQUIREMENTS = {
  BILLING_ADDRESS: 'BillingAddress',
  PICKUP_ADDRESS: 'PickupAddress',
  PAYMENT_METHOD: 'PaymentMethod',
  NICKNAME: 'Nickname',
  IO_BLACK_BOX: 'IoBlackBox',
  TAX_ID_INFORMATION: 'TaxIdInformation',
};

export const SUPPORTED_PAYMENT_METHOD_TYPES = {
  CREDIT_CARD: 'CreditCard',
  STAMPS_CREDENTIALS: 'StampsAccountCredentials',
  STAMPS_SELLER_LABEL_PROVIDER: 'StampsSellerLabelProvider',
  ADYEN_DROP_IN_COMPONENT: 'AdyenDropInComponent',
  PAY_BY_BANK_US: 'PayByBankUS',
};

export const FORM_REQUIREMENTS = {
  BILLING_ADDRESS: 'BillingAddress',
  PICKUP_ADDRESS: 'PickupAddress',
  PAYMENT_METHOD: 'PaymentMethod',
  PAYMENT_METHOD_TYPE: 'PaymentMethodType',
  CREDIT_CARD: 'CreditCardInfo',
  STAMPS_CREDENTIALS: 'StampsAccountCredentials',
  STAMPS_SELLER_LABEL_PROVIDER: 'StampsSellerLabelProvider',
  TERMS: 'AgreeToTerms',
  NONDEFAULT_TERMS: 'NonDefaultAcceptedTerms',
  UPS_TERMS: 'UpsTermsAccepted',
  ACCOUNT_TYPE: 'AccountType',
  NICKNAME: 'Nickname',
  METADATA: 'MetaData',
  CURRENCY_CODE: 'CurrencyCode',
  WALLET_ID: 'WalletId',
  RESOURCES: 'Resources',
  LABEL_PROVIDER_IDS: 'LabelProviderIds',
  IO_BLACK_BOX: 'IoBlackBox',
  ACCEPTED_TERMS: 'AcceptedTerms',
  RESOURCE_UPDATE_IDS: 'ResourceUpdateIds',
  INSURANCE_PROVIDER_IDS: 'InsuranceProviderIds',
  ADYEN_SESSION_INFO: 'AdyenSessionInfo',
  IS_VALID_UNIFIED_PROMO_CODE: 'IsValidUnifiedPromoCode',
  TAX_ID_INFORMATION: 'TaxIdInformation',
};

export const PAYMENT_AND_LOCATION_FORMS = [
  FORM_REQUIREMENTS.BILLING_ADDRESS,
  FORM_REQUIREMENTS.PICKUP_ADDRESS,
  FORM_REQUIREMENTS.NICKNAME,
  FORM_REQUIREMENTS.IO_BLACK_BOX,
];

export const PAYMENT_AND_LOCATION_CREDIT_CARD_FORMS = [...PAYMENT_AND_LOCATION_FORMS, FORM_REQUIREMENTS.CREDIT_CARD];

export const paymentFields = {
  cardName: 'cardName',
  cardProvider: 'cardProvider',
  cardNumber: 'cardNumber',
  expiry: 'expiry',
  cvv: 'cvv',
};

// DEPRECATED
// constants below this line should be removed and replaced with their reusable forms elsewhere in the codebase
export const addressFields = {
  name: 'name',
  countryCode: 'countryCode',
  line1: 'line1',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode',
  phone: 'phone',
  email: 'email',
};
